export const telephoneMasks = [
  { mask: '(000) 000-0000' },
  { mask: '(000) 000-0000, ext 000000' }
];